import React, { useMemo } from 'react';
import { Popover } from '@material-ui/core';
import { Link } from '@this/shared/ui/navigations/link';

type Props = {
  children: React.ReactNode;
  tripIds?: number[];
};

export const ArrangementReportsPopup = ({ children, tripIds = [] }: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const styles = useMemo(() => getStyles(), []);

  if (tripIds.length === 0) {
    return <p>{children}</p>;
  }

  return (
    <>
      <a onClick={e => setAnchorEl(e.target as HTMLElement)}>{children}</a>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: -8,
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        onClose={() => setAnchorEl(null)}
      >
        <ul style={styles.popoverContent}>
          {tripIds.map(id => (
            <li key={id}>
              <Link href={`/arrangement/virtual_counter#${id}`} target="_blank">
                {id}
              </Link>
            </li>
          ))}
        </ul>
      </Popover>
    </>
  );
};

const getStyles = () => ({
  popoverContent: {
    display: 'flex' as const,
    flexDirection: 'column' as const,
    alignItems: 'center' as const,
    gap: 4,
    padding: 4,
    width: 80,
    maxHeight: 200
  }
});
